import React, { useState, useRef, useEffect } from 'react';
import { Button, TextField } from '@material-ui/core';
import { initializeStrapiBackend } from '../Contentful_API/strapiBackend';

export default function StaffLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  async function submit(event) {
    event.preventDefault();
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError('');
    try {
      const { apiUrl } = await initializeStrapiBackend();
      const response = await fetch(`${apiUrl}/auth/local`, {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: email.trim(), password }),
      });
      if (!response.ok) {
        throw new Error(response.status === 400 || response.status === 401
          ? 'Sign-in failed. Check your email and password, or contact your administrator.'
          : 'Sign-in is currently unavailable. Please try again later.');
      }
      const data = await response.json();
      if (typeof data.jwt !== 'string' || !data.jwt || !data.user) {
        throw new Error('Sign-in is currently unavailable. Please try again later.');
      }
      // The server must verify approval, role and organisation before allowing staff chat.
      const access = await fetch(`${apiUrl}/chat/access`, {
        credentials: 'omit', headers: { Authorization: `Bearer ${data.jwt}` },
      });
      if (!access.ok) {
        throw new Error(access.status === 403
          ? 'Your account does not have ministry or agency chat access. Contact your administrator.'
          : 'Staff chat access could not be verified. Please contact your administrator.');
      }
      const permission = await access.json();
      if (permission.allowed !== true) {
        throw new Error('Your account is not approved for staff chat. Contact your administrator.');
      }
      if (mounted.current) onLogin({ token: data.jwt, apiUrl, email: data.user.email || email.trim() });
    } catch (err) {
      if (mounted.current) setError(err instanceof TypeError ? 'Unable to connect. Please try again later.' : err.message);
    } finally {
      if (mounted.current) {
        setPassword('');
        setBusy(false);
      }
      pending.current = false;
    }
  }

  return (
    <form onSubmit={submit} style={{ maxWidth: 440, margin: '0 auto' }}>
      <h2 style={{ fontSize: 20 }}>Ministry & agency sign-in</h2>
      <p>Use the email and password registered by your Strapi administrator. Contact your administrator to request an account or reset your password.</p>
      <TextField id="chat-staff-email" label="Email address" type="email" autoComplete="username" required fullWidth margin="normal" variant="outlined" value={email} disabled={busy} onChange={e => setEmail(e.target.value)} />
      <TextField id="chat-staff-password" label="Password" type="password" autoComplete="current-password" required fullWidth margin="normal" variant="outlined" value={password} disabled={busy} onChange={e => setPassword(e.target.value)} />
      {error && <p role="alert" style={{ color: '#a12622' }}>{error}</p>}
      <Button type="submit" variant="contained" color="primary" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</Button>
      <p style={{ fontSize: 12 }}>You will need to sign in again after refreshing or closing this window.</p>
    </form>
  );
}
